import { Instagram, ExternalLink } from "lucide-react";

// User can later swap these placeholder tiles with real post thumbnails + deep links
const POSTS = [
  {
    img: "/assets/chatgpt-image-apr-24-2025-03_06_19-pm.png",
    caption: "Welcome Home.",
  },
  {
    img: "/assets/chatgpt-image-apr-24-2025-03_30_11-pm.png",
    caption: "Meet Jayden.",
  },
  {
    img: "/assets/chatgpt-image-apr-24-2025-03_12_33-pm.png",
    caption: "Meet Ariana.",
  },
  {
    img: "/assets/365-challenge-day-2-announcement-copy.jpg",
    caption: "#Foster365 Challenge",
  },
  {
    img: "/assets/500-k-stat-web-slice-copy.jpg",
    caption: "500,000 kids.",
  },
  {
    img: "/assets/chatgpt-image-apr-24-2025-04_50_07-pm.png",
    caption: "Meet Sophia.",
  },
];

const HANDLE = "fostercareawareness365";
const PROFILE_URL = `https://www.instagram.com/${HANDLE}/`;

export default function InstagramFeed() {
  return (
    <section className="bg-fc-surface border-y border-fc-border" data-testid="home-instagram-feed">
      <div className="container-xl py-20 md:py-24">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-10">
          <div>
            <div className="overline text-fc-muted mb-3 flex items-center gap-2">
              <Instagram size={14} /> Follow the mission
            </div>
            <h2 className="font-display text-4xl md:text-6xl leading-none">
              @{HANDLE.slice(0, 18)}<span className="text-fc-accent">365</span>
            </h2>
            <p className="mt-5 text-fc-muted max-w-xl leading-relaxed">
              Daily stories, kid spotlights, and #Foster365 Challenge updates — straight from the Instagram feed.
            </p>
          </div>
          <a
            href={PROFILE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary"
            data-testid="ig-follow-btn"
          >
            <Instagram size={14} /> Follow on Instagram
          </a>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-2">
          {POSTS.map((p, i) => (
            <a
              key={i}
              href={PROFILE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative aspect-square overflow-hidden border border-fc-border bg-fc-bg"
              data-testid={`ig-post-${i}`}
            >
              <img src={p.img} alt={p.caption} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <div className="absolute inset-0 bg-fc-ink/0 group-hover:bg-fc-ink/60 transition-colors duration-300 flex items-end">
                <div className="p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-between w-full">
                  <div className="text-fc-bg text-xs font-mono leading-tight pr-2">{p.caption}</div>
                  <Instagram size={14} className="text-fc-bg shrink-0" />
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-6 flex items-center justify-between flex-wrap gap-4 text-sm text-fc-muted">
          <div className="font-mono">Posts · Reels · Stories</div>
          <a href={PROFILE_URL} target="_blank" rel="noopener noreferrer" className="overline link-ul flex items-center gap-1 text-fc-ink" data-testid="ig-view-profile">
            View Full Profile <ExternalLink size={12} />
          </a>
        </div>
      </div>
    </section>
  );
}
